import {Component} from '@angular/core'
import {NgForOf, NgIf} from '@angular/common'
import {Toast, ToastService, ToastType} from '../../services/helpers/toast.service'

/**
 * The one place toasts are rendered. Mounted once, in app.component.html.
 *
 * Same four tones and icons as the inline messages in _messages.scss, so a success on a page and
 * a success in the corner are recognisably the same thing — but carried by a tinted icon chip
 * rather than notice's coloured edge. The brand crimson appears in none of them: it means "act".
 */
@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [NgForOf, NgIf],
  template: `
    <div class="toast-host">
      <div *ngFor="let toast of toastSvc.toasts; trackBy: trackById"
           class="toast toast-{{toast.type}}"
           [class.toast-leaving]="toast.leaving"
           [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
           [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
           (mouseenter)="toastSvc.pause(toast.id)"
           (mouseleave)="toastSvc.resume(toast.id)"
           (click)="toastSvc.dismiss(toast.id)">
        <span class="toast-icon"><i class="fas {{icon[toast.type]}}"></i></span>
        <div class="min-w-0 flex-1 py-0.5">
          <p class="text-sm font-semibold text-gray-900 mb-0.5" *ngIf="toast.title">{{toast.title}}</p>
          <p class="text-sm text-gray-600">{{toast.message}}</p>
          <button *ngIf="toast.action" type="button" class="basic-link text-sm font-medium mt-1.5"
                  (click)="toast.action.run()">{{toast.action.label}}</button>
        </div>
        <button type="button" class="toast-close" aria-label="Dismiss">
          <i class="fas fa-xmark"></i>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent {
  readonly icon: Record<ToastType, string> = {
    success: 'fa-circle-check',
    error: 'fa-circle-exclamation',
    warning: 'fa-triangle-exclamation',
    info: 'fa-circle-info'
  }

  constructor(public toastSvc: ToastService) {}

  trackById(_: number, toast: Toast) { return toast.id }
}
